$(document).ready(function(){            
    $('.team-slider').removeClass('row flex-nowrap').slick({
        dots: false,
        arrows: true,
        speed: 500,
        slidesToScroll: 4,
        slidesToShow: 4,
        variableWidth: false,
        infinite: false,
        responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
            {
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
        ]
    });
});